// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"2a0e1336","79":"2205ba71","160":"96913b7f","328":"a767b444","374":"58956fcc","432":"5d81695b","623":"e972ce0e","705":"95d0902f","787":"327f1571","858":"5ab2d6e9","862":"445804df","956":"72f2d44e"}[chunkId] + ".chunk.js";
};